import { Button, Modal, notification } from 'antd'
import {
  ClockCircleOutlined,
  MobileOutlined,
  UnlockOutlined,
} from '@ant-design/icons'
import { formatBackendDateTimeNaive } from 'global/util/time'
import NoData from 'components/NoData'
import propTypes from 'global/propTypes'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'
import { useTranslation } from 'react-i18next'

import './deviceDetailsList.less'

const DeviceDetailsList = ({ devices, isUnlockingDeviceId, onUnlock }) => {
  const { t } = useTranslation()

  const handleUnlockClick = device => {
    Modal.confirm({
      cancelText: t(
        'portCall.shipOverview.deviceDetailsInfo.unlockConfirm.cancel'
      ),
      content: t(
        'portCall.shipOverview.deviceDetailsInfo.unlockConfirm.description',
        { bayNumber: device.bayNumber }
      ),
      okButtonProps: { danger: true },
      okText: t('portCall.shipOverview.deviceDetailsInfo.unlockConfirm.ok'),
      onOk: () =>
        new Promise(resolve => {
          onUnlock(device.deviceId, device.bayNumber, isSuccessful => {
            if (isSuccessful) {
              notification.success({
                message: t(
                  'portCall.shipOverview.deviceDetailsInfo.unlockSuccess',
                  { bayNumber: device.bayNumber }
                ),
              })
            }

            resolve()
          })
        }),
      title: t('portCall.shipOverview.deviceDetailsInfo.unlockConfirm.title'),
    })
  }

  if (!devices || devices.length === 0) {
    return (
      <div className="device-details-list__empty">
        <NoData />
      </div>
    )
  }

  return (
    <div className="device-details-list">
      {devices.map(device => {
        const isUnlocking = isUnlockingDeviceId === device.deviceId

        return (
          <div className="device-details-list__item" key={device.deviceId}>
            <div className="device-details-list__item-header">
              <div className="device-details-list__device-name">
                <MobileOutlined className="device-details-list__device-icon" />
                <Text isBold>{device.deviceName}</Text>
              </div>

              <Button
                danger
                disabled={isUnlockingDeviceId !== null}
                icon={<UnlockOutlined />}
                loading={isUnlocking}
                onClick={() => handleUnlockClick(device)}
                size="small"
              >
                {t('portCall.shipOverview.deviceDetailsInfo.unlock')}
              </Button>
            </div>

            <div className="device-details-list__row">
              <Text className="device-details-list__row-label">
                {`${t('portCall.shipOverview.bay')}:`}
              </Text>
              <Text>{device.bayNumber}</Text>
            </div>

            <div className="device-details-list__row">
              <ClockCircleOutlined className="device-details-list__time-icon" />
              <Text className="device-details-list__row-label">
                {`${t('portCall.shipOverview.deviceDetailsInfo.lockedAt')}:`}
              </Text>
              <Text>
                {device.lockedAt
                  ? formatBackendDateTimeNaive(device.lockedAt)
                  : t('portCall.shipOverview.deviceDetailsInfo.unknownTime')}
              </Text>
            </div>
          </div>
        )
      })}
    </div>
  )
}

DeviceDetailsList.defaultProps = {
  isUnlockingDeviceId: null,
}

DeviceDetailsList.propTypes = {
  devices: PropTypes.arrayOf(propTypes.shipOverviewDevice).isRequired,
  isUnlockingDeviceId: PropTypes.string,
  onUnlock: PropTypes.func.isRequired,
}

export default DeviceDetailsList
